import Modal from '@mui/material/Modal';
import { useState, useEffect, memo, useCallback } from 'react';
import { AccountApi } from '../apis';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '500px',
  alignItems: 'flex-start',
  backgroundColor: '#ffffff',
  border: '1px solid',
  borderColor: '#b6bcc5',
  borderRadius: '10px',
  display: 'inline-flex',
  flexDirection: 'column',
  gap: '30px',
  justifyContent: 'center',
  padding: '50px 50px 40px',
  with: '450px',
};
const inputStyle = {
  borderBottom: '1px solid #b6bcc5',
  borderTop: '1px solid #b6bcc5',
  width: '100%',
  gap: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  fontSize: '16px',
  fontWeight: '400',
  padding: '20px 0',
};
const inputTagStyle = {
  border: '1px solid #b6bcc5',
  borderRadius: '10px',
  padding: '0px 15px',
  margin: '0px',
};
const disabledInputStyle = {
  ...inputTagStyle,
  background: '#E9ECEF',
  color: '#B6BCC5',
};
const inputGroupStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
};
const buttonStlye = {
  backgroundColor: '#FFF',
  border: '1px solid #b6bcc5',
  borderRadius: '10px',
  color: '#495057',
  fontSize: '16px',
  fontWeight: '500',
  padding: '7px 20px',
};

export default function ChangePassword(props) {
  const [changePasswordView, setChangePasswordView] = useState(false);
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordChar, setPasswordChar] = useState(false);
  const [passwordLower, setPasswordLower] = useState(false);
  const [passwordUpper, setPasswordUpper] = useState(false);
  const [passwordNum, setPasswordNum] = useState(false);
  const [passwordSame, setPasswordSame] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const togglePasswordVisibility = useCallback(() => {
    setShowPassword((prevState) => !prevState);
  }, []);
  const togglePasswordVisibility1 = useCallback(() => {
    setShowPassword1((prevState) => !prevState);
  }, []);
  const togglePasswordVisibility2 = useCallback(() => {
    setShowPassword2((prevState) => !prevState);
  }, []);

  const handleSetPassword = (e) => {
    let value = e.target.value;
    const regexLow = /[a-z]/;
    const regexUpp = /[A-Z]/;
    const regexNum = /\d/;
    setNewPassword(value);

    if (value.length >= '8') {
      setPasswordChar(true);
    } else {
      setPasswordChar(false);
    }
    if (regexLow.test(value)) {
      setPasswordLower(true);
    } else {
      setPasswordLower(false);
    }
    if (regexUpp.test(value)) {
      setPasswordUpper(true);
    } else {
      setPasswordUpper(false);
    }
    if (regexNum.test(value)) {
      setPasswordNum(true);
    } else {
      setPasswordNum(false);
    }
  };

  const changePassword = async () => {
    try {
      const response = await AccountApi.checkPassword(props.email, password);
      if (newPassword === confirmPassword) {
        const formData = new FormData();
        formData.append('email', props.email);
        formData.append('password', newPassword);
        const res = await AccountApi.changePassword(formData);
        if (res.statusCode === 200) {
          alert("Password changed successfully. Try to login with the new password.");
          props.handleModalClose();
          return;
        } else {
          alert(res.statusCode + '\n' + res.message);
          return;
        }
      } else {
        alert('The password is not the same.');
        return;
      }
       
    } catch (error) {
      alert('Failed to change password:', error);
    }
  };

  const backButton = () => {
    setChangePasswordView(false);
    setPasswordChar(false);
    setPasswordLower(false);
    setPasswordUpper(false);
    setPasswordNum(false);
    setPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setShowPassword(false);
    setShowPassword1(false);
    setShowPassword2(false);
    props.handleModalClose();
  };

  return (
    <Modal
      open={props.open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div style={{ ...style }}>
        <div
          style={{
            fontSize: '36px',
            fontWeight: '600',
          }}
        >
          SET NEW PASSWORD
        </div>
        <div style={{ ...inputStyle }}>
          {/* <div style={{ ...inputGroupStyle }}>
            <span>Password</span>
            <div style={{ position: 'relative' }}>
              <input
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  ...inputTagStyle,
                }}
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter current password..."
              />
              <button
                onClick={togglePasswordVisibility}
                style={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none',
                }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>
          </div> */}
          <div style={{ ...inputGroupStyle }}>
            <span>New Password</span>
            <div style={{ position: 'relative' }}>
              <input
                onChange={(e) => handleSetPassword(e)}
                style={{
                  ...inputTagStyle,
                }}
                type={showPassword1 ? 'text' : 'password'}
                placeholder="Password"
              />
              <button
                onClick={togglePasswordVisibility1}
                style={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none',
                }}
              >
                {showPassword1 ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                fontSize: '14px',
              }}
            >
              <div style={{ color: passwordChar ? '#000' : 'red' }}>
                {passwordChar ? <CheckIcon /> : <ClearIcon />}
                <span>At least 8 char</span>
              </div>
              <div style={{ color: passwordLower ? '#000' : 'red' }}>
                {passwordLower ? <CheckIcon /> : <ClearIcon />}
                <span>At least 1 lowercase character</span>
              </div>
              <div style={{ color: passwordUpper ? '#000' : 'red' }}>
                {passwordUpper ? <CheckIcon /> : <ClearIcon />}
                <span>At least 1 uppercase character</span>
              </div>
              <div style={{ color: passwordNum ? '#000' : 'red' }}>
                {passwordNum ? <CheckIcon /> : <ClearIcon />}
                <span>At least 1 number</span>
              </div>
            </div>
          </div>
          <div style={{ ...inputGroupStyle }}>
            <span>Confirm New Password</span>
            <div style={{ position: 'relative' }}>
              <input
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{
                  ...inputTagStyle,
                }}
                type={showPassword2 ? 'text' : 'password'}
                placeholder="Enter the new password again..."
              />
              <button
                onClick={togglePasswordVisibility2}
                style={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none',
                }}
              >
                {showPassword2 ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>
            {confirmPassword.length !== 0 && newPassword !== confirmPassword ? (
              <div style={{ fontSize: '14px', color: 'red', height: '20px' }}>
                <ClearIcon />
                <span>The password is not the same.</span>
              </div>
            ) : (
              <div style={{ height: '20px' }}></div>
            )}
          </div>
        </div>
        <div style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <button style={{ ...buttonStlye }} onClick={() => backButton()}>
              Cancel
            </button>
            <button
              onClick={changePassword}
              disabled={
                !passwordChar ||
                !passwordLower ||
                !passwordUpper ||
                !passwordNum ||
                newPassword !== confirmPassword //||
                //password === ''
              }
              style={{
                ...buttonStlye,
                marginLeft: '10px',
                backgroundColor:
                  newPassword === confirmPassword &&
                  //password.length !== 0 &&
                  passwordChar &&
                  passwordLower &&
                  passwordUpper &&
                  passwordNum
                    ? '#000'
                    : '#d6d6d6',
                color: '#FFF',
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
